import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['No sabés qué preguntar cuando la lectura se estanca.', 'Dependés únicamente de lo que aparezca en el momento.', 'Dudás frente a símbolos o mensajes complejos.', 'No tenés herramientas claras para intervenir.', 'Las sesiones pierden profundidad.', 'Te cuesta sostener procesos de transformación.', 'Sentís que algunas consultas podrían haber llegado más lejos.', 'Cada sesión empieza desde cero.'];
  return <Section className="max-w-4xl" data-id="element-342">
      <div className="text-center mb-12" data-id="element-343">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-purpleDark" data-id="element-344">
          ¿Cuántas sesiones más vas a improvisar?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-345">
          Sabés abrir registros. Sabés conectar. Sabés sostener el espacio. Pero
          muchas veces llegás a la sesión sin saber exactamente cómo intervenir.
          No porque te falte intuición. No porque te falte vocación. Sino porque
          nadie te enseñó a trabajar con un sistema profesional.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-346">
          No es falta de don. Es falta de método.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-purple/20" data-id="element-347">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-purpleDark text-base md:text-lg" data-id="element-348">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-349" /> Lo que
          pasa sin el Kit Profesional del Interventor Akáshico:
        </h3>
        <ul className="space-y-4" data-id="element-350">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-351">
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-352" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-353">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-354">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-355">
          ¿Y si esta fuera la última sesión que trabajás así?
        </h3>
      </div>
    </Section>;
};